import { AxiosResponse } from "axios";
import axiosClient from "../common/axios/axiosConfig";

export interface IReview {
	_id: string;
	aprovado: boolean;
	criado: string;
	descricao: string;
	nota: number;
	pessoa: string | null;
	profissional: string;
	agendamento: string;
}

// TODO: apos rota ser arrumada, adicionar toast caso der erro
export const getReviews = (codProfessional: string): Promise<AxiosResponse<IReview[]>> => {
	return axiosClient.get(`/review/professional/${codProfessional}`);
};
